// @ts-nocheck
import { COLUMN_REVERSE_MAP, OVERVIEW_LOOKUP_NAMES } from 'src/constants/constants';
import { ILookUpFilterListModal, ILookUpDetailModal } from 'src/models/IOverviewModel';

export const mergeFilters = (mainFilters: any, subFilters: any) => {
    let cacheFilters: any = [...mainFilters];

    subFilters.forEach((filter: any) => {
        let filtered_list = cacheFilters.filter((main: any) =>
        (main.column !== filter.column
            && main.column !== COLUMN_REVERSE_MAP[filter.column as keyof typeof COLUMN_REVERSE_MAP]));
        if (filter.value && filter.value.length > 0 && !(filter.value.includes("All".toLocaleLowerCase()))) {
            cacheFilters = [...filtered_list, filter];
        } else {
            cacheFilters = [...filtered_list];
        }
    })

    return cacheFilters;
}

export const mapFilterColumns = (mainFilters: any) => {
    let updatedFilters = [];
    updatedFilters = mainFilters.map((filter: any) => {
        return {
            ...filter,
            column: COLUMN_REVERSE_MAP[filter.column as keyof typeof COLUMN_REVERSE_MAP] || filter.column
        }
    });
    return updatedFilters;
}

export const getUniqueoptions = (arr: any, field: string) => {
    let data = new Map(arr.map((item: any) => [item[field], item])).values();
    return [...data];
}

export const loadSelectOptions = (lookupData: ILookUpDetailModal[], column:string, parent: string) => {

    if (parent) {
        let aggregateMap: any = {}
        lookupData.forEach((lookup_detail: ILookUpDetailModal) => {
            if (!aggregateMap[lookup_detail[parent]]) {
                aggregateMap[lookup_detail[parent]] = []
            }
            aggregateMap[lookup_detail[parent]].push({
                text: lookup_detail.display_text,
                value: lookup_detail.lookup_value,
                lookup_column: lookup_detail.lookup_column,
            });
        });
        return Object.keys(aggregateMap).map((agKey) => {
            return {
                parent: agKey,
                child: aggregateMap[agKey]
            }
        });
    } else {
        let loadOptions: any = [];
        
        loadOptions = lookupData.map((lookup_detail: ILookUpDetailModal) => {
            return {
                text: lookup_detail.display_text,
                value: lookup_detail.lookup_value,
                lookup_column: lookup_detail.lookup_column,
            }
        });
        return loadOptions;
    }

}

export const generateFilterObject = (filterList: ILookUpFilterListModal[], selctedFilterValues: string[], filterName: string) => {
    const serializedFilterObject: any = filterList.find((filterItem: ILookUpFilterListModal) => filterItem.lookup_name === filterName);
    switch (filterName) {
        
        case OVERVIEW_LOOKUP_NAMES.DOLLAR_VALUE:
            return [{
                column: filterName,
                value: [selctedFilterValues[0],selctedFilterValues[1]],
                type: serializedFilterObject.filter_type,
            }]
        case OVERVIEW_LOOKUP_NAMES.COUNTRY:
            const country_data = serializedFilterObject.lookup_detail.filter((country) => selctedFilterValues.includes(country.lookup_value));
            return [{
                column: serializedFilterObject.lookup_name,
                value: [...country_data.map((country: string) => country.country_code)],
                displayValues: [...country_data.map((country: string) => country.display_text)],
                type: serializedFilterObject.filter_type,
            }]
        case OVERVIEW_LOOKUP_NAMES.STATUS:
            const status_data = serializedFilterObject.lookup_detail.find((status) => selctedFilterValues.includes(status.lookup_value));
            return [{
                column: status_data.lookup_column,
                value: [status_data.lookup_value],
                displayValues: [status_data.lookup_value],
                type: serializedFilterObject.filter_type,
            }]
        case OVERVIEW_LOOKUP_NAMES.ALERT:
                const alert_data = serializedFilterObject.lookup_detail.filter((alert) => selctedFilterValues.includes(alert.display_text));
                return [{
                    column: serializedFilterObject.lookup_name,
                    value: [...alert_data.map((alert: string) => alert.lookup_value)],
                    displayValues: [...alert_data.map((alert: string) => alert.display_text)],
                    type: serializedFilterObject.filter_type,
                }]
        default:
            return [{
                column: filterName,
                value: [...selctedFilterValues],
                type: serializedFilterObject.filter_type
            }]
    }
}
